import { Editor } from 'slate'

export const getBlockAbove = (editor, options = {}) =>
  Editor.above(editor, {
    match: (n) => Editor.isBlock(editor, n),
    ...options
  }) || [editor, []]
